<template>
  <v-container>
    <!-- Snackbar para ver errors -->
    <v-snackbar v-model="snackbar" :timeout="8000" top :color="color" dark  > {{text}}
      <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>

    <v-row align="center" justify="center">
      <v-col cols="12"  align="center">
      	<v-card-actions>
      	  <v-btn color="success"     tile small @click="dialogEntrada = true, tipo = 1">Entrada</v-btn>
      	  <v-btn color="red"   dark  tile small @click="dialogSalida  = true, tipo = 2">Salida</v-btn>
      	  <v-btn color="info " dark  tile small @click="dialogCorte   = true, tipo = 5">Efectivo</v-btn>

      	  <v-spacer></v-spacer>
      	  <v-btn color="orange" dark tile small @click="dialogCerrar = true ">C. Caja</v-btn>
      	</v-card-actions>
      </v-col>
    </v-row>

    <!-- Abrir la caja -->
    <v-row align="center" justify="center">
      <v-col cols="12"  align="center">
        <v-card class="shadowCard">
          <v-data-table
            :headers="headers"
            :items="movimientos"
            hide-default-footer
            height="450"
            fixed-header
            :items-per-page="length"
            >
            <template v-slot:item.tipo="{item}">
              <div v-if="item.tipo ==1" class="green--text">Entrada</div>
              <div v-if="item.tipo ==2" class="red--text">Salida</div>
              <div v-if="item.tipo ==3" class="blue--text">Cancelación</div>
              <div v-if="item.tipo ==4" class="orange--text">Devolución</div>
            </template>

            <template v-slot:item.tipopago="{item}">
              <div v-if="item.tipopago ==1">Efectivo</div>
              <div v-if="item.tipopago ==2">Cheque</div>
              <div v-if="item.tipopago ==3">Transferencia</div>
              <div v-if="item.tipopago ==4">Tarjeta</div>
            </template>

            <template v-slot:item.opciones="{item}">
            	<v-tooltip bottom>
  				      <template v-slot:activator="{ on, attrs }">
  				      	<v-btn color="red" small icon
  				      		v-bind="attrs"
  				          v-on="on"
  				          @click="validarNivel(3), idmovimiento = item.idmovimientos"
  				      	><v-icon>mdi-close</v-icon></v-btn>
  				      </template>
  				      <span>Cancelar</span>
  				    </v-tooltip>

  				    <v-tooltip bottom>
  				      <template v-slot:activator="{ on, attrs }">
  				      	<v-btn color="orange" small icon
  				      		v-bind="attrs"
  				          v-on="on"
  				          @click="validarNivel(4), idmovimiento = item.idmovimientos"
  				      	><v-icon>mdi-backup-restore</v-icon></v-btn>
  				      </template>
  				      <span>Devolución</span>
  				    </v-tooltip>
            </template>

          </v-data-table>
        </v-card>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>

    <!-- Agregar una nueva entrada -->
    <v-row justify="center" v-if="dialogEntrada">
      <v-dialog v-model="dialogEntrada" persistent max-width="350px" >
        <v-card>
          <v-card-title class="text-subtitle-1">Agregar Entrada
          	<v-spacer></v-spacer>
          	<v-btn color="red" icon @click="dialogEntrada=false,limpiar()"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-form
			      ref="form"
			      v-model="valid"
			      :lazy-validation="lazy"
			    >
	          <v-card-text>
	          	<v-text-field
	          	  outlined
	          	  label="Folio"
	          	  v-model="folio"
	          	  dense
	          	  :rules="requerido"
	          	  hide-details
	          	></v-text-field>

	          	<v-radio-group
					      v-model="tpago"
	          	  label="Tipo de pago"
					      column
					      class="mb-2"
					    >
					      <v-radio
					      	v-for="(t, i) in tipopago"
					      	:key="i"
					        :label="t.text"
					        :value="t.valor"
					      ></v-radio>
					    </v-radio-group>

	          	<v-text-field
	          		type="number"
	          	  outlined
	          	  :rules="requerido"
	          	  label="Total a pagar"
	          	  v-model="cantidad"
	          	  dense
	          	></v-text-field>

	          	<v-text-field
	          		type="number"
	          	  outlined
	          	  :rules="requerido"
	          	  label="Pago recibído"
	          	  v-model="pago"
	          	  dense
	          	></v-text-field>

	          	<v-text-field
	          		type="number"
	          	  outlined
	          	  label="Cambio"
	          	  v-model="cambio"
	          	  dense
	          	></v-text-field>
        		</v-col>

	          	<v-textarea 
	          		v-model="concepto" 
	          		:rules="requerido" 
	          		label="concepto" 
	          		dense 
	          		outlined
	          	></v-textarea>
	          </v-card-text>
	        </v-form>
          <v-card-actions>
            <v-btn 
            	color="black"
            	dark
            	small
            	tile 
            	@click="dialogEntrada = false, limpiar()"
            >
            	<v-icon small left>mdi-cancel</v-icon>
          		Cancelar
          	</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
            	color="green" 
            	dark
            	tile
            	small
            	@click="addEntrada" :disabled="!valid"
            >
            	<v-icon small left>mdi-content-save</v-icon>
          		Aceptar
          	</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Agregar una salida -->
    <v-row justify="center" v-if="dialogSalida">
      <v-dialog v-model="dialogSalida" persistent max-width="350px" >
        <v-card>
          <v-card-title class="text-subtitle-1">Agregar Salida
          	<v-spacer></v-spacer>
          	<v-btn color="red" icon @click="dialogSalida=false,limpiar()"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-form
			      ref="form"
			      v-model="valid"
			      :lazy-validation="lazy"
			    >
	          <v-card-text>
	          	<v-text-field
	          	  outlined
	          	  label="Folio"
	          	  v-model="folio"
	          	  dense
	          	  :rules="requerido"
	          	  hide-details
	          	></v-text-field>

	          	<v-radio-group
					      v-model="tpago"
	          	  label="Tipo de pago"
					      column
					      class="mb-2"
					    >
					      <v-radio
					      	v-for="(t, i) in tipopago"
					      	:key="i"
					        :label="t.text"
					        :value="t.valor"
					      ></v-radio>
					    </v-radio-group>

	          	<v-text-field
	          		type="number"
	          	  outlined
	          	  :rules="requerido"
	          	  label="Total a pagar"
	          	  v-model="cantidad"
	          	  dense
	          	></v-text-field>

	          	<v-text-field
	          		type="number"
	          	  outlined
	          	  :rules="requerido"
	          	  label="Pago recibído"
	          	  v-model="pago"
	          	  dense
	          	></v-text-field>

	          	<v-text-field
	          		type="number"
	          	  outlined
	          	  label="Cambio"
	          	  v-model="cambio"
	          	  dense
	          	></v-text-field>
        		</v-col>

	          	<v-textarea 
	          		v-model="concepto" 
	          		:rules="requerido" 
	          		label="concepto" 
	          		dense 
	          		outlined
	          	></v-textarea>

	          </v-card-text>
	        </v-form>
          <v-card-actions>
            <v-btn 
            	color="black"
            	dark
            	small
            	tile 
            	@click="dialogSalida = false, limpiar()"
            >
            	<v-icon small left>mdi-cancel</v-icon>
          		Cancelar
          	</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
            	color="green" 
            	dark
            	tile
            	small
            	@click="addEntrada" :disabled="!valid"
            >
            	<v-icon small left>mdi-content-save</v-icon>
          		Aceptar
          	</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

     <!-- Validar el usuario -->
    <v-row justify="center" v-if="dialogAdmin">
      <v-dialog v-model="dialogAdmin" persistent max-width="450px" >
        <v-card>
          <v-card-title class="hijo">Porfavor ingresa credenciales
          	<v-spacer></v-spacer>
          	<v-btn color="red" icon @click="dialogAdmin=false,limpiar()"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-form
			      ref="form"
			      v-model="valid"
			      :lazy-validation="lazy"
			    >
	          <v-card-text>
	          	<v-row>
	          		<v-col cols="12" >
			          	<v-text-field
			          	  outlined
			          	  label="Usuario"
			          	  v-model="email"
			          	  dense
			          	  :rules="requerido"
			          	></v-text-field>
	          		</v-col>

	          		<v-col cols="12" >
			          	<v-text-field
			          	  outlined
			          	  :rules="requerido"
			          	  label="Contraseña"
			          	  v-model="password"
			          	  dense
			          	></v-text-field>
	          		</v-col>

	          	</v-row>
	          </v-card-text>
	        </v-form>
          <v-card-actions>
            <v-btn 
            	color="black"
            	dark
            	small
            	tile 
            	@click="dialogAdmin = false, limpiar()"
            >
          		<v-icon small left>mdi-cancel</v-icon>
          		Cancelar
          	</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
            	color="green" 
            	dark
            	small
            	tile
            	@click="validarUsuario" :disabled="!valid"
            >
          		<v-icon small left>mdi-conten-save</v-icon>
          		Aceptar
          	</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- dialogo de cancelación  -->
    <v-row justify="center" v-if="dialogCancelacion">
      <v-dialog v-model="dialogCancelacion" persistent max-width="450px" >
        <v-card>
          <v-card-title class="hijo">Porfavor ingresa credenciales
          	<v-spacer></v-spacer>
          	<v-btn color="red" icon @click="dialogCancelacion=false,limpiar()"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-form
			      ref="form"
			      v-model="valid"
			      :lazy-validation="lazy"
			    >
	          <v-card-text>
	          	<v-row>
	          		<v-col cols="12" >
			          	<v-textarea v-model="concepto2" :rules="requerido" label="Razón de la cancelación o devolución" dense outlined></v-textarea>
	          		</v-col>
	          	</v-row>
	          </v-card-text>
	        </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogCancelacion = false, limpiar()">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="cancelarEntrada()" :disabled="!valid">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- dialog cerrar caja  -->
    <v-row justify="center" v-if="dialogCerrar">
      <v-dialog v-model="dialogCerrar" persistent max-width="500px" >
        <v-card>
          <v-card-title class="text-subtitle-1">
          	Cierre de caja
          </v-card-title>
          <v-divider></v-divider>
          <v-form
			      ref="form"
			      v-model="valid"
			      :lazy-validation="lazy"
			    >
	          <v-card-text>
	          	<v-row class="pb-0 mb-0">
	          		<v-col cols="8">
			          	<v-text-field
			          	  type="number"
			          	  label="Dinero en caja"
			          	  v-model="dineroCaja"
			          	  filled
			          	  dense
			          	></v-text-field>
	          		</v-col>
	          	</v-row>
	          	<v-row class="pt-0 mt-0">
	          		<v-card-text>
	          			<v-data-table
					          :headers="headersPago"
					          :items="tipoPagos"
					          hide-default-footer
					          height="200"
					          fixed-header
					          :items-per-page="lengthPagos"
					          dense
					        >
                    <template v-slot:item.cantidad="props">
                      <v-edit-dialog
                        :return-value.sync="props.item.cantidad"
                        @save="save"
                        @cancel="cancel"
                        @open="open"
                        @close="close"
                      > {{ props.item.cantidad }}
                        <template v-slot:input>
                          <v-text-field
                            v-model="props.item.cantidad"
                            label="Edit"
                            single-line
                            type="number"
                            counter
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </template>
					        </v-data-table>
                  <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
                    {{ snackText }}

                    <template v-slot:action="{ attrs }">
                      <v-btn v-bind="attrs" text @click="snack = false">Close</v-btn>
                    </template>
                  </v-snackbar>
	          		</v-card-text>
	          	</v-row>
	          </v-card-text>
	        </v-form>
          <v-card-actions>
            <v-btn 
            	color="black"
            	small
            	dark 
            	tile
            	@click="dialogCerrar = false, limpiar()"
            >
          		<v-icon small left>mdi-cancel</v-icon>
          		Cancelar
          	</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
            	color="green"
            	small 
            	dark 
            	tile
            	@click="cerrarCaja()" :disabled="!valid"
            >
          		<v-icon small left>mdi-content-save</v-icon>
          		Aceptar
          	</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

		<v-dialog v-model="dialogCorte" persistent max-width="350px">
			<v-card class="pa-3">
				<v-card-actions class="font-weight-black headline"> RETIRO DE CAJA </v-card-actions>
				<v-text-field 
					v-model.number="corte" 
					filled 
					hide-details 
					dense 
					placeholder="Cantidad a retirar" 
					type="number" 
					class="pa-2"
				>
				</v-text-field>
				<v-card-actions>
					<v-btn 
						@click="dialogCorte = false" 
						small
						tile 
						color="black"
						dark
					>
						<v-icon small left>mdi-cancel</v-icon>
						Cerrar
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn 
						@click="generaCorte" 
						color="green" 
						dark
						small
						tile
					>
						<v-icon small left>mdi-content-save</v-icon>
						Generar corte
					</v-btn>
			</v-card-actions>
			</v-card>
			
		</v-dialog>
    
  </v-container>
</template>

<script>
  // var moment = require('moment');
  // moment.locale('es');
  import {mapGetters, mapActions} from 'vuex'
  export default {
    data: () => ({
      // Snackbar para cerrar caja
      snack: false,
      snackColor: '',
      snackText: '',
    	// Cierre de caja
    	dialogCerrar: false,
    	dineroCaja: 0,
      efectivo:0,
      cheuqe:0,
      transferencia:0,
      tarjeta:0,
      fecha: new Date().toISOString().substr(0, 10),

    	// Validar nivel del usuario
    	dialogAdmin: false,
    	email:'',
    	password:'',
    	// Salida
    	dialogSalida: false,
    	// cancelación
    	dialogCancelacion: false,
    	idAutorizo:0,
			idmovimiento:'',
			//CORTE
			dialogCorte: false,
			corte:0,
			

    	// Validaciones
    	valid: true,
    	lazy: false,
    	requerido: [v => !!v || 'Campo requerido'],

      snackbar: false,
      color:'success',
      text:'',

      mensaje:'',

      snack: false,
      snackColor: '',
      snackText: '',
      saldoinicial:0,

      // Pagos
      headersPago:[
        {text: 'Movimiento', value:'tipopago'},
        {text: 'Cantidad', value:'cantidad'},
      ],
     	tipoPagos:[
	      {tipopago: 'Efectivo', cantidad:0},
	      {tipopago: 'Cheque', cantidad:0},
	      {tipopago: 'Transfer', cantidad:0},
	      {tipopago: 'Tarjeta', cantidad:0}
      ],
      lengthPagos: 5,


      headers:[
        {text: 'id', value:'idmovim'},
        {text: 'Estatus', value:'tipo'},
        {text: 'Folio', value:'folio'},
        {text: 'Concepto', value:'concepto'},
        {text: 'Total', value:'cantidad'},
        {text: 'Pago', value:'pago'},
        {text: 'Cambio', value:'cambio'},
        {text: 'Tipo de pago', value:'tipopago'},
        // {text: 'Autorización', value:'autorizacion'},
        // {text: 'Concepto por cancelcacion', value:'concepto2'},
        {text: 'Hora', value:'hora'},
        {text: 'Opciones', value:'opciones'},
      ],

      movimientos:[],

      length: 5,

      // Entradas
      dialogEntrada: false,
      // Tipo de movimiento 1-. Entrada 2-.Salida 3-.Cancelación 4-.Devolución
      // Tipo de pago 1-. Efectivo 2-.Tarjeta 3-. 
      cantidad:0,
      concepto:'',
      folio:'',
    	tipopago:[{text:'Efectivo',valor:1},{ text:'Cheque',valor:2},{ text:'Transferencia',valor:3},{ text:'Tarjeta',valor:4}],
    	tpago:{text:'Efectivo',valor:1},
      tipo:1,
      cambio:0,
      pago:0,
      concepto2:'',

    }),

    watch:{
    	cantidad(){
    		if(this.pago != 0 || this.pago  != ''){
    			this.cambio = this.pago - this.cantidad
    		}
    	},

    	pago(){
    		if(this.pago != 0 || this.pago  != ''){
    			this.cambio = this.pago - this.cantidad
    		}
    	}
    },

    computed:{
      ...mapGetters('login',['getdatosUsuario','getIdCaja'])
    },

    created(){
      this.initialize()
    },

    methods:{
			generaCorte(){
				const payload = { id_caja: this.getIdCaja, 
													fecha: this.fecha,
													hora: this.hora(),
													corte: this.corte 
												}
				this.$http.post('genera.corte',payload).then( response =>{
					console.log('generar corte', response.body)
					this.snackbar= true; this.text = response.body;
				}).catch(error=>{
					this.capturadeError(error.body.message)
				}).finally() 
			},	
      initialize () {
        this.efectivo      = 0
        this.cheque        = 0
        this.transferencia = 0
        this.tarjeta       = 0
      	this.dineroCaja    = 0
      	this.tipoPagos[0].cantidad = 0
      	this.tipoPagos[1].cantidad = 0
      	this.tipoPagos[2].cantidad = 0
      	this.tipoPagos[3].cantidad = 0
      	// dejar las cantidades en 0
        // Saber si la caja esta abierta
        var payload = {idusuario: this.getdatosUsuario.id}
        this.$http.get('movimientos/' + this.getIdCaja).then(response=>{
          var id = 0
          console.log(response)
          this.movimientos = response.body
          this.length = this.movimientos.length

          for(const i in this.movimientos){
            id += 1
          	if(this.movimientos[i].tipo == 1){
              this.movimientos[i].idmovim = id
          		console.log(this.movimientos[i])
	          	this.dineroCaja += this.movimientos[i].cantidad
	          	switch(this.movimientos[i].tipopago){
	          		case 1:
	          			this.efectivo = this.efectivo + this.movimientos[i].cantidad
	          		break;
	          		case 2:
	          			this.cheque = this.cheque + this.movimientos[i].cantidad
	          		break;
	          		case 3:
	          			this.transferencia = this.transferencia + this.movimientos[i].cantidad
	          		break;
	          		case 4:
	          			this.tarjeta = this.tarjeta + this.movimientos[i].cantidad
	          		break;
	          	}
          	}
          }

          console.log(this.dineroCaja)
        }).catch(error=>{
          this.mensaje = error.body.message
          console.log(error)
        })
      },

      ver(value){
        console.log(value)
      },

      hora(){
        var f =new Date();
        var hora = f.getHours()
        var minuto = f.getMinutes()
        var segundo = f.getSeconds()   
        if(hora < 10){
          hora = "0" + f.getHours()
        }
        if(minuto < 10){
          minuto = "0" + f.getMinutes() 
        }
        if(segundo < 10){
          segundo = "0" + f.getSeconds()
        }
        return hora + ":" + minuto + ":" + segundo
      },

      limpiar(){
      	this.cantidad = 0, this.concepto= '', this.folio = '', this.cambio = 0, this.pago = 0, this.$refs.form.reset()
      },

      addEntrada(){
      	var payload = {
			    idcaja: this.getIdCaja,
			    cantidad: this.cantidad,
			    concepto: this.concepto,
			    folio: this.folio,
			    tipopago: this.tpago,
			    tipo: this.tipo,
			    cambio: this.cambio,
			    pago: this.pago,
			    concepto2: '',
			    hora: this.hora()
				}

				this.$http.post('add.movim', payload).then(response=>{
					this.text = 'Movimiento agregado'
					this.color = 'success'
					this.snackbar  = true
					this.limpiar()
					this.dialogEntrada = false
					this.dialogSalida = false
					this.initialize()
				}).catch(error=>{
					this.capturadeError(error.body.message)
				})

				console.log(payload)
      },

      validarNivel(value){
      	this.tipo = value
      	if(this.getdatosUsuario.admin == 'ADMIN'){
      		console.log('Admin')
          this.idAutorizo = this.getdatosUsuario.id
          this.dialogCancelacion = true
          this.dialogAdmin = false
      	}else{
      		this.dialogAdmin = true
      		console.log('no es admin, es: ', this.getdatosUsuario.admin)
      	}
      },

      capturadeError(value){
        this.color = 'error'
        this.text = value
        this.snackbar = true
      },

      validarUsuario(){
        var md5     = require('md5')
      	var usuario = { "email" : this.email, "password": md5(this.password)}
      	this.$http.post('sessions', usuario).then(response=>{
	        console.log('response',response.body)
					if(!response.body.length){
						this.color = 'error'
		        this.text = 'No encontre el usuario, valida tus datos'
		        this.snackbar = true
					}else{
						if(response.body[0].admin == 'ADMIN'){
							this.idAutorizo = response.body[0].id
							this.dialogCancelacion = true
							this.dialogAdmin = false
							console.log('acceso deirecto') 
						}else{
							this.color = 'error'
			        this.text = 'Llamar a un administrador'
			        this.snackbar = true
			        this.email = '', this.password = '', this.$refs.form.reset()
						}
	      	}
	    	}, error => {
	      	console(false)
	    	})
      },

      cancelarEntrada(){
      	var payload = {
			    tipo: this.tipo,
			    concepto2: this.concepto2,
			    autorizacion: this.idAutorizo,
				}

				this.$http.put('cancelacion/' + this.idmovimiento, payload).then(response=>{
					this.text = 'Movimiento actualizado'
					this.color = 'success'
					this.snackbar  = true
					this.email = '', this.password = '', this.$refs.form.reset()
					this.limpiar()
					this.dialogCancelacion = false
					this.initialize()
				}).catch(error=>{
					this.capturadeError(error.body.message)
				})
      },

      cerrarCaja(){
        var payloadcerrar = {
          id_caja: this.getIdCaja,
          fecha: this.fecha,
          hora: this.hora(),
          total: this.dineroCaja,
          id_usuario: this.getdatosUsuario.id
        }
        this.$http.post('cerrar.caja',payloadcerrar).then(response=>{
          var payloaddetalle = [
            { id_cierre: response.body.id, tipo: 1, cantidad: this.efectivo,      reportado: this.tipoPagos[0].cantidad },
            { id_cierre: response.body.id, tipo: 2, cantidad: this.cheque,        reportado: this.tipoPagos[1].cantidad },
            { id_cierre: response.body.id, tipo: 3, cantidad: this.transferencia, reportado: this.tipoPagos[2].cantidad },
            { id_cierre: response.body.id, tipo: 4, cantidad: this.tarjeta,       reportado: this.tipoPagos[3].cantidad },
          ]

          this.$http.post('detalle.cierre',payloaddetalle).then(response=>{
            this.text = 'Caja cerrada'
            this.color = 'success'
            this.snackbar  = true
            this.dialogCerrar = false
            this.$router.push({name:'login',params:{id: this.getdatosUsuario.id}})
          }).catch(error=>{
            this.capturadeError(error.body.message)
          })
        }).catch(error=>{
          this.capturadeError(error.body.message)
        })

      },

      cancel () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      open () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      close () {
        console.log('Dialog closed')
      },
      save () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved'
        // Inicializamos el saldo inicial en 0
        this.saldoinicial = 0
        // Hacemos un recorrido para saber cuanto dinero tiene la caja
        for(const i in this.denominaciones){
          this.saldoinicial += (this.denominaciones[i].text * this.denominaciones[i].cantidad)
        }
      },

    }
  }

</script>

<style scoped>
  .padre{
    background: #11437C;  
    background: -webkit-linear-gradient(to right, #11437C, #12608D, #00B7D0);  
    background: linear-gradient(to right, #11437C, #12608D, #00B7D0);

    align-items: center;
  }

  .hijo{
    font-size: calc(1em + 1vw);
    font-family: 'Times New Roman' !important;
  }
</style>

